/*
 Selectively import from Bootstrap what you need: (add modules to exports to prevent tree shaking, see below)
 */
// import Alert from 'bootstrap/js/dist/alert'
import Button from 'bootstrap/js/dist/button'
import Carousel from 'bootstrap/js/dist/carousel';
import Collapse from 'bootstrap/js/dist/collapse';
import Dropdown from 'bootstrap/js/dist/dropdown';
import Modal from 'bootstrap/js/dist/modal';
import Offcanvas from 'bootstrap/js/dist/offcanvas'
// import Popover from 'bootstrap/js/dist/popover'
// import ScrollSpy from 'bootstrap/js/dist/scrollspy'
// import Tab from 'bootstrap/js/dist/tab'
// import Toast from 'bootstrap/js/dist/toast'
// import Tooltip from 'bootstrap/js/dist/tooltip'
import { Carousel as FancyCarousel } from '@fancyapps/ui/dist/carousel';
import { Arrows } from '@fancyapps/ui/dist/carousel/carousel.arrows';
import { Autoplay} from '@fancyapps/ui/dist/carousel/carousel.autoplay'
import { Dots } from '@fancyapps/ui/dist/carousel/carousel.dots';
import { Lazyload } from '@fancyapps/ui/dist/carousel/carousel.lazyload';
import { Fancybox } from '@fancyapps/ui/dist/fancybox';
import { de_DE } from '@fancyapps/ui/dist/fancybox/l10n/de_DE';
import { de_DE as de_DE_carousel } from '@fancyapps/ui/dist/carousel/l10n/de_DE';
import '../JavaScript/site-init.mjs';

/*
 CSS files are compiled by being imported in JS – that's just a way to tell the build system; they are not actually
 included in JS
 */
import '@fancyapps/ui/dist/carousel/carousel.css';
import '@fancyapps/ui/dist/fancybox/fancybox.css';
import '@fancyapps/ui/dist/carousel/carousel.arrows.css'
import '@fancyapps/ui/dist/carousel/carousel.dots.css'
import '../Scss/site.scss';

// prevent tree shaking
export {
  Button,
  Carousel,
  Collapse,
  Dropdown,
  FancyCarousel,
  Fancybox,
  Modal,
  Offcanvas,
};

class Site {
  constructor() {
    // init stuff:

    /**
     * Slider Homepage
     */
    const homeSliders = document.getElementsByClassName("slider carousel__1") as HTMLCollectionOf<Element>;
    for(let homeSlides of Array.prototype.slice.call(homeSliders) as Element[]) {
      FancyCarousel((homeSlides as HTMLElement), {
        // options
        l10n: de_DE_carousel,
        transition: 'slide',
        infinite: true,
        Autoplay: {
          pauseOnHover: true,
          timeout: 5000,
          showProgressbar: false,
        }
      }, {
        Autoplay,
        Lazyload,
        Arrows,
      }).init();
    }

    /**
     * Slider News
     */
    const newsSliders = document.getElementsByClassName("slider news__slider") as HTMLCollectionOf<Element>;
    for(let newsSlides of Array.prototype.slice.call(newsSliders) as Element[]) {
      FancyCarousel((newsSlides as HTMLElement), {
        // options
        l10n: de_DE_carousel,
        transition: 'slide',
        infinite: true,
        center: false,
      }, {
        Lazyload,
      }).init();
    }

    Fancybox.bind("[data-fancybox]", {
      l10n: de_DE,
    });
  }
}

new Site();
